module.exports = __webpack_public_path__ + "static/media/jingles_PIZZA10.a1821b8c.ogg";